// resources/js/Pages/Formula/components/ComponentActions.js
import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

export default function ComponentActions({ 
  onAdd, 
  onDelete, 
  onMove,
  addLabel = "Add",
  showDelete = true,
  showMove = false,
  position = "top-right"
}) {
  const positionStyles = {
    'top-right': { position: 'absolute', top: '8px', right: '8px' },
    'bottom-center': { position: 'absolute', bottom: '8px', left: '50%', transform: 'translateX(-50%)' },
    'inline': { display: 'inline-flex', marginLeft: '8px' }
  };

  return (
    <div 
      className="component-actions" 
      style={{
        ...positionStyles[position],
        zIndex: 10,
        opacity: 0,
        transition: 'opacity 0.2s ease'
      }}
    >
      <ButtonGroup size="sm">
        {onAdd && (
          <Button variant="outline-primary" onClick={onAdd} title={`${addLabel}`}>
            <small>+ {addLabel}</small>
          </Button>
        )}
        {showMove && onMove && (
          <Button variant="outline-secondary" onClick={onMove} title="Reorder">
            ⋮⋮
          </Button>
        )}
        {showDelete && onDelete && (
          <Button variant="outline-danger" onClick={onDelete} title="Delete">
            ×
          </Button>
        )}
      </ButtonGroup>
    </div>
  );
}